var map = {
  "./": "118736",
  "./awsBeta": "634859",
  "./awsBeta.js": "634859",
  "./docker": "441574",
  "./docker.js": "441574",
  "./index": "118736",
  "./index.js": "118736",
  "./local": "856727",
  "./local.js": "856727",
  "./production": "415485",
  "./production.js": "415485",
  "./sandbox": "61899",
  "./sandbox-se": "931132",
  "./sandbox-se.js": "931132",
  "./sandbox.js": "61899",
  "./tailwindScope.json": "958643"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = function() { return Object.keys(map); };
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 806886;
